
const BASE_URL_V1 = import.meta.env.VITE_API_BASE_URL + '/api/v1';

// Auth routes
export const REGISTER = `${BASE_URL_V1}/register`;
export const SEND_OTP = `${BASE_URL_V1}/send-otp`;
export const VERIFY_OTP = `${BASE_URL_V1}/verify-otp`;
export const LOGIN = `${BASE_URL_V1}/login`;

// Notification routes
export const NOTIFICATIONS = `${BASE_URL_V1}/notifications`;
export const NOTIFICATIONS_UNREAD_COUNT = `${BASE_URL_V1}/notifications/unread-count`;

// GPS subscription + tracking routes
export const GPS_SUBSCRIPTION_PURCHASE = `${BASE_URL_V1}/subscription/purchase`;
export const GPS_SUBSCRIPTION_MY = `${BASE_URL_V1}/subscription/my`;
export const GPS_ASSIGN_DEVICE = `${BASE_URL_V1}/gps/assign-device`;
export const GPS_LOCATION = `${BASE_URL_V1}/gps/location`;